
<template>
  <div >
    <div class="header">
      <h1>HIROAPY</h1>
      <h2>Questions Fréquentes</h2>
  </div>
  <div class="container" style="min-height: 600px;max-height: 1000px;">
    <v-flex xs12  text-xs-center>
      <VueFaqAccordion 
    :items="myItems"
  />
    </v-flex>
  </div>
  <subFooter />
  </div>
</template>

<script>
const subFooter = () => import("../components/subFooter");
import VueFaqAccordion from 'vue-faq-accordion'
let tab1 = 'Général'
let tab2  = 'Fonctionement de HIROPAY'
let tab3 = "Contact"
 
export default {
  
  components: {
    VueFaqAccordion,
    subFooter
  },
  data () {
    return {
      myItems: [
          {
            title: "Comment s'inscrire sur HIROPAY",
            value: `Avant de commencer votre inscription, il est essentiel de prendre quelques précautions pour garantir la sécurité de votre connexion. Veuillez vérifier la barre de navigation de votre navigateur pour vous assurer que votre connexion est sécurisée et que l'adresse correspond bien à <a href="https://hiropay.com">https://hiropay.com</a>. Cela garantit que vous êtes sur le site officiel de HIROPAY et que vos informations personnelles seront protégées.<br /><br />Pour vous inscrire sur la plateforme, cliquez sur S'INSCRIRE dans le menu de navigation. Cela vous dirigera vers la page dédiée à l'inscription, où vous devrez fournir certaines informations requises, telles que votre nom, votre adresse e-mail et un mot de passe sécurisé.<br />Une fois que vous avez rempli tous les champs nécessaires, cliquez sur S'INSCRIRE pour valider votre inscription. Cela déclenchera l'envoi d'un e-mail contenant un lien de confirmation à l'adresse que vous avez fournie.<br /><br />Vérifiez votre boîte de réception (et éventuellement votre dossier de courrier indésirable) pour trouver cet e-mail. Cliquez sur le lien de confirmation inclus dans le message pour finaliser votre inscription. Ce processus est une mesure de sécurité qui vous permet de confirmer que vous êtes bien le propriétaire de l'adresse e-mail renseignée.<br /><br />BRAVO ! Vous êtes maintenant membre de HIROPAY, et vous êtes prêt à explorer toutes les fonctionnalités de la plateforme. Vous pourrez bientôt effectuer votre première transaction en toute simplicité et profiter des avantages offerts par le service. Si vous avez des questions ou avez besoin d'aide, n'hésitez pas à consulter notre section d'assistance ou à contacter notre service clientèle.`,
            category: tab1
          },
          {
            title: 'Comment se connecter',
            value: `Pour accéder à votre compte, commencez par cliquer sur LOGIN dans le menu de navigation, ce qui ouvrira la fenêtre de connexion. Une fois la fenêtre affichée, suivez les étapes suivantes :<br />1- Dans le premier champ, entrez votre Email associé à votre compte.<br />2- Ensuite, dans le champ suivant, saisissez votre mot de passe en veillant à respecter la casse et à ne pas inclure d'espaces supplémentaires.<br />3- Une fois que vous avez vérifié que vos informations sont correctes, cliquez sur le bouton LOGIN. Vous serez alors connecté à votre compte et pourrez accéder à toutes les fonctionnalités et services offerts par la plateforme.`,
            category: tab1
          },
          {
            title: "J'ai perdu mon mot de passe que faire?",
            value: "Si vous perdez votre mot de passe, vous devez le réinitialiser et en créer un nouveau.<br />Pour ce faire :<br />1- Cliquez sur CONNEXION dans le menu de navigation.<br />2- Tout en bas de l'espace de connexion, cliquez sur MOT DE PASSE OUBLIÉ.<br />3- Entrez votre Email et cliquez sur Reinitialiser.<br />4- Allez dans votre boîte email et cliquez sur le lien reçu. Vous serez redirigé vers une page pour créer votre nouveau mot de passe !",
            category: tab1
          },

          {
            title: "Comment fonctionne HIROPAY",
            value: `HIROPAY est une plateforme d'achat et de vente de cryptomonnaie.<br />Une fois connecté, sélectionnez la devise à donner dans la section DONNER et celle à recevoir dans la section RECEVOIR.<br />Entrez le montant à donner ou à recevoir, ainsi que votre adresse de réception.<br />Vous pouvez alors procéder à l'échange.`,
            category: tab2
          },

          {
            title: "Combien de temps durent les échanges sur HIROPAY",
            value: `Les transactions sur HIROPAY sont instantanées, à l'exception des délais liés aux confirmations blockchain, nécessaires pour valider les échanges en toute sécurité.<br />Dans le cas où un utilisateur aurait renseigné des informations incorrectes (comme une adresse erronée ou un montant inexact), le service à la clientèle est disponible pour intervenir rapidement.<br />Un membre de l'équipe de support contactera l’utilisateur dans un bref délai afin de corriger toute erreur et de s’assurer que l’échange soit finalisé dans les plus brefs délais, garantissant ainsi un service fiable et sécurisé.`,
            category: tab2
          },

          {
            title: `Quels sont les moyens de paiement disponible sur HIROPAY`,
            value: `HIROPAY dessert les pays de l'Afrique francophone en proposant des moyens de paiement adaptés aux spécificités de cette région.<br />La plateforme intègre divers services de paiement mobile largement utilisés dans ces pays, tels que :<br />MTN Mobile Money, Orange Money, Airtel Money, Flooz, Wave, TMoney, et Express Union.<br />Ces méthodes de paiement mobile facilitent l'accès à la cryptomonnaie pour les utilisateurs, en rendant les transactions plus accessibles et pratiques dans l'écosystème financier africain.`,
            category: tab2
          },

          {
            title: "Comment contacter HIROPAY",
            value: `Pour contacter HIROPAY, vous avez plusieurs options à votre disposition. Si vous préférez discuter directement avec un représentant, vous pouvez les joindre par téléphone au numéro suivant : (+228) 91918524. Assurez-vous d'avoir toutes les informations nécessaires à portée de main pour que votre demande soit traitée efficacement.<br /><br />Si vous souhaitez envoyer une demande par écrit ou poser une question spécifique, vous pouvez également les contacter par email à l'adresse support@hiropay.com. Dans votre message, n'oubliez pas de fournir des détails pertinents concernant votre demande afin de faciliter une réponse rapide et précise.<br /><br />Enfin, HIROPAY est également disponible sur WhatsApp. Vous pouvez les contacter via le même numéro (+228) 91918524 sur WhatsApp pour une assistance rapide et pratique. Que vous choisissiez de les appeler, de leur écrire ou de les contacter via WhatsApp, l'équipe de HIROPAY est là pour vous aider et répondre à toutes vos questions.`,
            category: tab3
          },

          
        ]
    }
  },
  metaInfo() {
    return {
      title: 'FAQ - HIROPAY : Réponses à vos questions sur le change de devises et cryptomonnaies',
      meta: [
        {
          name: 'description',
          content: `Retrouvez toutes les réponses à vos questions sur HIROPAY, la plateforme de change de devises et cryptomonnaies en Franc CFA XOF. Découvrez comment acheter, vendre et échanger des devises traditionnelles et des monnaies digitales comme le Bitcoin en toute simplicité.`,
        },
        {
          name: 'keywords',
          content: 'FAQ, HIROPAY, change de devises, cryptomonnaies, Franc CFA XOF, Bitcoin, échange monnaie digitale, questions fréquentes, Togo, Benin, cameroun, cote divoire, senegal, mali, burkina faso',
        },
        {
          name: 'author',
          content: 'HIROPAY',
        },
        {
          property: 'og:title',
          content: 'FAQ - HIROPAY : Réponses sur le change de devises et cryptomonnaies',
        },
        {
          property: 'og:description',
          content: `Retrouvez les réponses aux questions les plus fréquentes sur HIROPAY, concernant le change de devises et les cryptomonnaies comme le Bitcoin.`,
        },
        {
          property: 'og:image',
          content: 'https://hiropay.com/assets/tmoney.png', // Remplacez par une image représentative si disponible
        },
        {
          property: 'og:url',
          content: 'https://hiropay.com/faq',
        },
      ],
    };
  },
}
</script>

<style>
    /* Reset */
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    /* Base Colors */
    :root {
        --primary-color: #003449;
        --secondary-color: #005f99;
        --background-color: #f4f8fb;
        --text-color: #333;
        --accent-color: #ffaa00;
    }

    /* Layout */
 

    .container {
        max-width: 900px;
        margin: 0 auto;
       
    }

    div.header {
        background-color: #003449;
        color: #fff;
        padding: 20px 0;
        text-align: center;
        border-bottom: 4px solid var(--accent-color);
    }

    h1 {
        font-size: 2.5em;
        margin-bottom: 0.5em;
    }

    h2 {
        font-size: 1.2em;
        font-weight: 300;
    }


    h3 {
        font-size: 1.8em;
        color: var(--primary-color);
        margin-bottom: 0.5em;
    }

    h4 {
        font-size: 1.4em;
        color: var(--secondary-color);
        margin-top: 1em;
    }

    p {
        margin-bottom: 1em;
        text-align: justify;
    }

    footer {
        background-color: var(--secondary-color);
        color: #fff;
        text-align: center;
        padding: 10px 0;
        margin-top: 20px;
    }

    /* Enhancements */
    #terms, #privacy {
        background-color: #fff;
        padding: 20px;
        margin-bottom: 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }

    footer p {
        font-size: 0.9em;
    }

    /* Appliquer une marge gauche aux éléments de liste */
    ul, ol {
        margin-left: 50px;
    }

    ul li, ol li {
        margin-bottom: 0.5em;
    }
</style>